import React, { useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { updateProjectDetailsHazardousMaterials } from '../../api';
import SpinnerNew from "../Spinner/SpinnerNew";
import MultiselectExtension from "components/MultiselectExtension";

import { HazardousValueOptions } from 'components/TaskList/DisabledTasks';

function HazardousSelectionDialog({ onClose, project, initialSelectedArray, onSave }) {

    const [spinnerOn, setSpinnerOn] = useState(false);
    const [selectedValueString, setSelectedValueString] = useState('');

    const handleEvent = (values) =>{
            let str = null;
            if (values.length > 0 ) {
            str = values.sort(function (a, b) { return (a.id - b.id) }).map(t => { return t.label }).join(',');
            }
            if(values.length >= 1){
                setSelectedValueString(str);
            }
            if(values.length === 0){
                console.log(values.length)
                setSelectedValueString('')
            }          
    }

    return (
        <div className='react-confirm-alert-body'>
          <SpinnerNew display={spinnerOn}/>
            <div className='edit-dialog--task'>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        Please select at least one Hazardous Option.
                    </Col>
                </Row>
                <br/>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        <MultiselectExtension options={HazardousValueOptions}
                                                    showCheckbox={true}
                                                    displayValue="value"
                                                    placeholder="Select or Remove Hazardous"
                                                    selectedValues={(initialSelectedArray !== null && initialSelectedArray !== undefined && initialSelectedArray.length > 0) ?
                                                         HazardousValueOptions.filter(t => initialSelectedArray.split(',').includes(t.value)) : []}                            
                                                     onSelect={handleEvent}
                                                     onRemove={handleEvent}
                                                    />
                    </Col>
                </Row>
            </div>
            <br />
            <Row style={{ textAlign: 'left' }}>
                <Col xs={8} md={8} lg={8}>
                    <button disabled={(selectedValueString.length == 0)}
                            className='btn btn-primary start-5'
                            onClick={async () => {
                                await onSave(selectedValueString);
                                onClose(true);
                            }}
                    >
                        Save
                    </button>
                    <button disabled={false}
                            className='btn btn-primary start-5'
                            onClick={() => {
                               onClose();
                            }}
                    >
                        Cancel
                    </button>
                </Col>
             </Row>
        </div>
    );
}

export default HazardousSelectionDialog;
